import Splide from "@splidejs/splide";

export function initHeroCarousels() {
	const carousels = document.querySelectorAll(".js-hero-carousel");

	carousels.forEach((carousel) => {
		const splide = new Splide(carousel, {
			type: "loop",
			perPage: 1,
			perMove: 1,
			arrows: false,
			pagination: true,
			autoplay: true,
			interval: 5000,
			pauseOnHover: true,
			pauseOnFocus: true,
			speed: 700
		});

		splide.mount();
	});
}
